var resolutions = {highstaging:{scale:1,id:'highstaging',height:1334,webp:true},h1000staging:{scale:0.75,id:'h1000staging',height:1000,webp:true}};
